export class RecommendedList {
	Id: number;
	Title: string;
	Total: number;
	IsExist: boolean;
}
